module.exports = __webpack_public_path__ + "i18n/ko_b36ba8e2b2893e74894a90afd6fbfecf.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ko.json
// module id = a8i3
// module chunks = 154